import { Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDrawerStore } from '../../store';
import { useBaseStore, useCreateData, useUpdateData } from '../../hooks';
import { BaseModel, FormField } from '../../types';
import { BaseModelSchema } from '../../lib/schemas';
import FormDrawer from '../ui/FormDrawer';
import ErrorModal from '../ui/modal/ErrorModal';

interface GenericFormProps {
  api: string;
  moduleName: string;
}
const GenericForm: React.FC<GenericFormProps> = ({ api, moduleName }) => {
  const drawerStore = useDrawerStore();
  const baseStore = useBaseStore();
  const [spinning, setSpinning] = useState<boolean>(false);
  const [isInfoModalOpen, setInfoModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>('');

  const {
    mutate,
    isSuccess: isSuccessCreate,
    isError: isErrorCreate,
    error: errorCreate,
  } = useCreateData(api);
  const {
    mutate: mutateUpdate,
    isSuccess: isSuccessUpdate,
    isError: isErrorUpdate,
    error: errorUpdate,
  } = useUpdateData(api);

  const formFields: FormField[] = [
    {
      name: 'code',
      label: 'Code',
      rules: [{ required: true, message: 'Please enter Code' }],
      disabled: baseStore.data != null,
      defaultValue: baseStore.data?.code,
    },
    {
      name: 'description',
      label: 'Description',
      rules: [{ required: true, message: 'Please enter description' }],
      defaultValue: baseStore.data?.description,
    },
  ];

  const onFinish = (values: BaseModel) => {
    setSpinning(true);
    if (baseStore.data !== null) {
      const oldData = BaseModelSchema.parse(baseStore.data);
      const updatedData = {
        ...oldData,
        description: values.description,
      };
      mutateUpdate({ id: oldData.id, form: updatedData });
    } else {
      mutate(values);
    }
  };

  useEffect(() => {
    if (isSuccessCreate || isSuccessUpdate || isErrorUpdate || isErrorCreate)
      setSpinning(false);

    if (isErrorUpdate) {
      setInfoModalOpen(true);
      setErrorMessage(errorUpdate?.response?.data.message);
    }
    if (isErrorCreate) {
      setInfoModalOpen(true);
      setErrorMessage(errorCreate?.response?.data.message);
    }
  }, [
    isSuccessCreate,
    isSuccessUpdate,
    isErrorUpdate,
    isErrorCreate,
    errorCreate,
  ]);
  return (
    <>
      <Spin spinning={spinning} fullscreen />
      <FormDrawer
        isOpen={drawerStore.isOpen}
        onClose={drawerStore.onClose}
        data={baseStore.data}
        moduleName={moduleName}
        setData={baseStore.setData}
        onFinish={onFinish}
        formFields={formFields}
      />
      <ErrorModal
        visible={isInfoModalOpen}
        message={errorMessage}
        onClose={() => setInfoModalOpen(false)}
      />
    </>
  );
};

export default GenericForm;
